module.exports = __webpack_public_path__ + "img/flow_3.bb9eee11.png";